/**
 *
 * MaterialCourseCpnt
 *
 */

import { /* mapState, */ mapGetters } from 'vuex';
//import _ from 'lodash';
//import Swal from 'sweetalert2';

import MaterialFile from '@/views/MainMode/MainModeCourse/MainModeMaterial/components/MaterialFile.vue';

export default {
  name: 'MainModeMaterial',

  components: {
    MaterialFile,
  },

  computed: {
    //...mapState('MainModeCourse', {
    //  ms_isMaterialLoading: 'isMaterialLoading',
    //}),

    ...mapGetters({
      Files: 'MainModeCourse/Files',
    }),
  },
};
